import React from 'react';
// --- IMPORTAR useNavigate ---
import { useNavigate } from 'react-router-dom';
import './PrivacyPolicyPage.css'; // Importa los estilos

const PrivacyPolicyPage = () => {
    // --- INICIALIZAR useNavigate ---
    const navigate = useNavigate();

    return (
        <div className="privacy-policy-container">
            {/* --- Botón de Volver (onClick CORREGIDO) --- */}
            <div className="back-button-container">
                {/* Usa navigate('/') para ir siempre a la LandingPage */}
                <button className="back-button" onClick={() => navigate('/landing')}>
                    <span role="img" aria-label="Flecha izquierda">←</span> Volver
                </button>
            </div>

            <h1>Aviso de privacidad</h1>

            <section>
                <p>Aviso de protección de datos personales:</p>
                <p>
                    La protección de sus datos personales es de suma importancia para nosotros. Por eso, PathData, A.C., en adelante VIKI, alineándonos a la Ley de Protección de Datos Personales en Posesión de los Particulares, y su Reglamento, respeta la privacidad y la confidencialidad de nuestros asociados y asociadas, empleados, proveedores, terceros y el público en general, y somos conscientes de los derechos que usted tiene en relación con la información personal que recopilamos sobre su persona. PathData, A.C., en adelante VIKI, apoya todas las leyes existentes y vigentes sobre la confidencialidad y protección de datos personales, locales y nacionales, y ha desplegado los mecanismos necesarios para el cumplimiento de dichas leyes.
                </p>
                <p>
                    Este aviso de privacidad tiene como objetivo informarle sobre cómo recopilamos, utilizamos, almacenamos y protegemos sus datos personales de acuerdo con la Ley Federal de Protección de Datos Personales en Posesión de los Particulares en México.
                </p>
            </section>

            <section>
                <h2>Responsable del tratamiento de datos personales.</h2>
                <p>
                    El responsable del tratamiento de sus datos personales es PathData, A.C., en adelante VIKI, con domicilio ubicado en 37 oriente, 610, Colonia San Baltazar Campeche, Ciudad de Puebla, Puebla, C.P. 72550.
                </p>
                <p>
                    Nos comprometemos a garantizar que sus datos sean tratados conforme a los principios de licitud, consentimiento, información, calidad, finalidad, lealtad, proporcionalidad y responsabilidad.
                </p>
            </section>

            <section>
                <h2>Datos personales que se recaban.</h2>
                <p>Recopilamos los siguientes datos personales:</p>
                <ul>
                    <li>Nombre completo.</li>
                    <li>Dirección física.</li>
                    <li>Correo electrónico.</li>
                    <li>Número telefónico.</li>
                    <li>Información de su Registro Federal de Contribuyentes.</li>
                    <li>Edad.</li>
                    <li>Sexo.</li>
                    <li>Antecedentes de salud física y mental.</li>
                    <li>Expediente clínico.</li>
                    <li>Información relacionada con su estado de salud como peso, estatura, padecimientos personales y de familiares, así como estado de bienestar físico y mental en general.</li>
                </ul>
            </section>

            <section>
                <h2>Finalidades del tratamiento de datos personales.</h2>
                <p>Sus datos personales serán utilizados para las siguientes finalidades:</p>
                <ul>
                    <li>Proveer los servicios que solicita.</li>
                    <li>Abrir el expediente correspondiente al servicio que solicita y mantener actualizado su registro en nuestra base de datos.</li>
                    <li>Procesar pagos y transacciones.</li>
                    <li>Generar comprobantes fiscales digitales emitidos por internet.</li>
                    <li>Informar sobre cambios en nuestros servicios o productos.</li>
                    <li>Evaluar la calidad del servicio.</li>
                    <li>Realizar estudios internos para mejorar nuestros procesos.</li>
                    <li>Invitación a nuestros eventos, congresos y campañas.</li>
                </ul>
                <p>
                    El objetivo que persigue VIKI con la recopilación de sus datos personales es el de ofrecerle la mejor experiencia con nosotros y un servicio tan personalizado como sea posible. Cuanto más se conozca sobre usted, VIKI estará en disposición de ofrecerle los mejores servicios.
                </p>
                <p>
                    En general, la información personal se solicita cuando usted se pone en contacto con nosotros para solicitar un servicio.
                </p>
                <p>
                    También utilizaremos sus datos de contacto para enviarle mensajes de correo electrónico. Estos mensajes directos sólo se los enviará VIKI (o aquellos agentes que trabajen para VIKI).
                </p>
                <p>
                    Conservación de los datos personales: Los datos personales que proporcione se conservarán o destruirán según las necesidades de la compañía y/o según lo establecido por las leyes locales o cuando así lo solicite el titular de estos.
                </p>
                <p>
                    Con quién compartimos estos datos: VIKI responsabiliza a sus asociados y asociadas, empleados y proveedores, del mantenimiento de la confianza que terceros y el público en general depositan en nosotros. Formamos a nuestros empleados y de manera periódica, comprobamos el cumplimiento de nuestras políticas de confidencialidad y seguridad.  VIKI no comercia con datos personales ni los vende a terceras partes. Revelaremos información personal sólo bajo mandato judicial.
                </p>
                <p>
                    VIKI recibe el consentimiento para develar cualquier información considerada sensible.
                </p>
                <p>
                    La cantidad de información personal que se le pedirá estará relacionada únicamente con los datos que necesitamos para cumplir con los fines descritos.
                </p>
                <p>
                    Puede utilizar el correo electrónico armando@path-data.com para solicitarnos la eliminación, acceso, rectificación, cancelación u oposición al uso de datos personales en de nuestras listas de correo y marketing. (Consulte más abajo el apartado ¿Cómo ponerse en contacto con nosotros?).
                </p>
            </section>

            <section>
                <h2>Opciones y medios para limitar el uso y divulgación de sus datos.</h2>
                <p>Puede ejercer su derecho a limitar el uso o divulgación de sus datos personales a través de los siguientes medios:</p>
                <ul>
                    <li>Enviando un correo electrónico al responsable del tratamiento de datos</li>
                    <li>Visitando nuestro domicilio y solicitando el formato correspondiente.</li>
                </ul>
                <p>Nos aseguraremos de atender su solicitud en un plazo no mayor a 20 días hábiles.</p>
            </section>

            <section>
                <h2>Transferencia de datos personales.</h2>
                <p>
                    En VIKI no realizamos transferencias de sus datos personales, y estos no serán compartidos con terceros sin su consentimiento, salvo aquellas previstas en el artículo 37 de la Ley Federal de Protección de Datos Personales en Posesión de los Particulares.
                </p>
            </section>

            <section>
                <h2>Duración de conservación.</h2>
                <p>
                    Conservaremos los datos personales durante: (i) el tiempo que sea necesario para la actividad o los servicios pertinentes; (ii) cualquier período de retención requerido por la legislación local; o (iii) el final del período en el que puedan surgir litigios o investigaciones que involucren sus datos personales. Cuando los datos personales ya no sean necesarios o relevantes para las finalidades mencionadas, serán eliminados de manera segura.
                </p>
            </section>

            <section>
                <h2>Medidas de seguridad para proteger su información personal.</h2>
                <p>
                    Su información personal será resguardada bajo estricta confidencialidad y para prevenir razonablemente el uso o divulgación indebida de la misma, hemos implementado medidas de seguridad tanto físicas, como técnicas y administrativas, de conformidad con la Ley Federal de Protección de Datos Personales en Posesión de los Particulares y demás normativa aplicable. En particular, contamos con una política de privacidad, cursos de capacitación para nuestros asociados y asociadas, y personas empleadas, acceso restringido a información personal solo a personas usuarias autorizadas, una persona oficial de privacidad, un inventario de datos personales (debidamente clasificados por categoría de datos), de los sistemas de tratamiento, análisis de riesgos y cláusulas contractuales.
                </p>
            </section>

            <section>
                <h2>Modificaciones al aviso de privacidad.</h2>
                <p>
                    Nos reservamos el derecho de realizar modificaciones al presente aviso de privacidad para cumplir con cambios legales, políticas internas o nuevos requerimientos. VIKI podrá modificar y/o actualizar el presente aviso de privacidad unilateralmente, informándole sobre cualquier modificación o actualización al ingresar a nuestras instalaciones, así como a través de nuestra página de internet.
                </p>
            </section>

            <section>
                <h2>Consentimiento.</h2>
                <p>
                    Nuestros principios de confidencialidad representan nuestro compromiso para asegurar que su información personal esté segura y en buen resguardo. Si cree que VIKI no ha cumplido estos principios y prácticas, póngase en contacto con nosotros y empezaremos a trabajar diligentemente para localizar y solucionar el problema con prontitud.  VIKI se compromete a colaborar con las autoridades encargadas de la protección de datos. Puede ponerse en contacto con ellas para hacer uso de esos mecanismos independientes.
                </p>
                <p>
                    Al aceptar las condiciones y términos establecidos por medio del presente aviso de privacidad se considera otorgado el consentimiento expreso para que  VIKI, haga uso de manejo y tratamiento de sus datos personales para los fines descritos.
                </p>
            </section>

            <section>
                <h2>¿Cómo ponerse en contacto con nosotros?</h2>
                <p>
                    Para cualquier consulta, queja o comentario relacionado con este aviso de privacidad, puede comunicarse con nosotros en:
                </p>
                <ul>
                    <li>armando@path-data.com</li>
                    <li>raquel@path-data.com</li>
                    <li>Domicilio: 37 oriente, 610, Colonia San Baltazar Campeche, Ciudad de Puebla, Puebla, C.P. 72550.</li>
                </ul>
                <p>
                    Este aviso de privacidad garantiza que sus derechos y datos personales están protegidos conforme a la legislación mexicana vigente.
                </p>
            </section>
        </div>
    );
};

export default PrivacyPolicyPage;
